export const REVIEWS_BASE_URL = 'https://api.juniphq.com';
export const REVIEWS_FORMS_BASE_URL = 'https://forms.juniphq.com';
